export enum DMSFileCategory {
  'Officers' = 'Officers',
  'Notes' = 'Notes',
  'Tax' = 'Tax',
  'Passport' = 'Passport',
  'IdentityCard' = 'IdentityCard',
  'BankDetails' = 'BankDetails',
  'ResidentialAddress' = 'ResidentialAddress',
  'RelatedCompanies' = 'RelatedCompanies',
  'RiskAssessment' = 'RiskAssessment',
  'Compliance' = 'Compliance',
}
